module.exports = __webpack_public_path__ + "static/media/clipboard-list.923c1f7b.svg";